<div class="relative">
  <div class="relative w-full h-16 mx-auto pb-3">
    <img
      src="/assets/images/top-pattern.png"
      alt="pattern"
      class="absolute inset-0 w-full h-full object-fill filter opacity-50"
    />

    <div class="relative h-16 flex items-center px-6 pb-6 w-11/12 mx-auto">
      <img src="/assets/images/emblem.png" alt="Coat of Arms" class="h-8 md:h-10 cursor-pointer"/>

      <div class="lg:border-r-4 border-r-2  border-primary-500 h-10 z-10 !ml-5"></div>

      <img src="/assets/images/logo_animated.gif"
           alt="Dirisha la Huduma za Serikali"
           class="h-12 cursor-pointer"/>

      <div class="!font-medium pr-2 text-primary-500">
        <span class="block text-sm md:text-xl">
         {{ "Dirisha la Hudumaza Serikali"|concat|translate }}
        </span>
      </div>
      <div class="flex-1"></div>

      <div class="flex items-center space-x-4 gap-2 z-10">
        <button
          *ngIf="activeLanguage=='en'"
          (click)="onChangeLanguage('sw')"
          class="flex items-center lg:text-lg md:text-md sm:text-sm text-xs  text-black hover:text-primary-900">
          Swahili
          <img src="/assets/images/flag-wind.png" class="h-4 w-auto mx-1 rounded-xl"/>
        </button>
        <button
          *ngIf="activeLanguage=='sw'"
          (click)="onChangeLanguage('en')"
          class="flex items-center lg:text-lg md:text-md sm:text-sm text-xs  text-black hover:text-primary-900">
          English
          <mat-icon svgIcon="globe" class="h-4 w-4 mx-1"></mat-icon>
        </button>


        <div class="cursor-pointer md:inline-block hidden" *ngIf="userProfile" (mouseover)="handleHover(null)">
          <div
            #t="matMenuTrigger"
            [matMenuTriggerFor]="userMenu"
            class="flex gap-1 items-center cursor-pointer rounded-full bg-secondary-50 border-[1px] !border-secondary px-1 py-0.5">
          <span class="d-flex align-items-center user-icon p-1">
            <mat-icon color="white"
                      svgIcon="person"></mat-icon>
            <!--            <ng-template #pic>-->
            <!--              <img *ngIf="!!photo" alt="P"-->
            <!--                   class="rounded cursor-pointer text-center"-->
            <!--                   [src]="photo"/>-->
            <!--            </ng-template>-->
          </span>
            <div class="flex flex-col">
              <span class="text-sm">{{ userProfile?.userFirstName }} {{ userProfile?.userLastName }}</span>
              <span class="text-xs" *ngIf="userProfile?.userEmail">{{ userProfile?.userEmail }}</span>
            </div>

            <div
              class="flex items-center justify-center">
              <mat-icon [class.open]="t.menuOpen" style="color: white !important" class="trigger-arrow !text-white"
                        svgIcon="chevron-down-black">
              </mat-icon>
            </div>
          </div>
        </div>
        <!--        <button-->
        <!--          class="flex items-center text-lg font-medium text-black hover:text-primary-900">-->
        <!--          Mipangilio-->
        <!--          <mat-icon class="h-4 w-4 mx-1 text-primary-500" svgIcon="settings"></mat-icon>-->
        <!--        </button>-->
      </div>
    </div>
  </div>
  <nav
    class="bg-white shadow-sm w-full z-50"
    [class.fixed]="showStickyNav"
    [class.relative]="!showStickyNav"
    [ngStyle]=" showStickyNav ? { top: '0', left: '0' } : {} ">
    <img
      src="/assets/images/flag-line.svg"
      alt="Tanzania flag stripe"
      class="w-full h-1.5 object-cover"/>

    <ul
      class="flex flex-wrap nav-links items-center text-xs font-semibold gap-4 justify-start md:justify-between w-11/12 mx-auto py-2">
      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover(null)">
        <a
          routerLink="/home"
          routerLinkActive="text-primary-500 border-b-2 border-primary-500"
          #homeRla="routerLinkActive"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span> {{ "Mwanzo" |concat|translate }}</span>
          <mat-icon class="align-middle text-sm">
            {{ homeRla.isActive ? 'south_west' : 'north_east' }}
          </mat-icon>
        </a>
      </li>

      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover('about-tgsd')">
        <a
          [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('about-tgsd')}"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span> {{ "Kuhusu Dirisha"|concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">
            {{ activeMenu('about-tgsd') ? 'south_west' : 'north_east' }}
          </mat-icon>
        </a>
      </li>

      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover('huduma-tgsd')">
        <a
          [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('huduma-tgsd')}"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span> {{ "Huduma zote"|concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">
            {{ activeMenu('huduma-tgsd') ? 'south_west' : 'north_east' }}
          </mat-icon>
        </a>
      </li>

      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover('dharura-tgsd')">
        <a
          [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('dharura-tgsd')}"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span>{{ "Dharura" |concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">
            {{ activeMenu('dharura-tgsd') ? 'south_west' : 'north_east' }}
          </mat-icon>
        </a>
      </li>

      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover('faq-tgsd')">
        <a
          [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('faq-tgsd')}"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span>{{ "FAQs" |concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">
            {{ activeMenu('faq-tgsd') ? 'south_west' : 'north_east' }}
          </mat-icon>
        </a>
      </li>

      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover('mrejesho-tgsd')">
        <a
          [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('mrejesho-tgsd')}"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span>{{ "Mrejesho" |concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">
            {{ activeMenu('mrejesho-tgsd') ? 'south_west' : 'north_east' }}
          </mat-icon>
        </a>
      </li>

      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover('msaada-ai')">
        <div
          (click)="msaadaAiClicked.emit()"
          class="flex items-center text-primary-600 hover:border-b-2 border-primary-500 hover:text-primary-500 pb-1 transition">
          <span>{{ "Msaada AI" |concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">
            {{ activeMenu('msaada-ai') ? 'south_west' : 'north_east' }}
          </mat-icon>
        </div>
      </li>

      <li class="cursor-pointer md:inline-block hidden" *ngIf="!userProfile" (mouseover)="handleHover(null)">
        <a
          routerLink="/login"
          routerLinkActive="text-primary-500 border-b-2 border-primary-500"
          #loginRla="routerLinkActive"
          class="flex items-center text-primary-600 hover:text-primary-500 pb-1 transition"
        >
          <span>{{ "Ingia/Jisajili" |concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">north_east</mat-icon>
        </a>
      </li>
      <li class="cursor-pointer md:inline-block hidden" (mouseover)="handleHover(null)">
        <a
          [routerLink]="userProfile?.profileType === 'CIT' ? '/client-services' : '/tgsd-landing'"
          routerLinkActive="text-primary-500 border-b-2 border-primary-500"
          #loginRla="routerLinkActive"
          class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition">
          <span>{{ "Dashboard"|concat|translate }}</span>
          <mat-icon class="align-middle text-sm ">north_east</mat-icon>
        </a>
      </li>


      <!--      <li class="cursor-pointer md:inline-block hidden" *ngIf="userProfile" (mouseover)="handleHover(null)">-->
      <!--        <button-->
      <!--          (click)="logout()"-->
      <!--          class="flex items-center text-primary-600  hover:text-red-600 gap-2 pb-1 transition"-->
      <!--        >-->
      <!--          <mat-icon svgIcon="logout" class="align-middle  text-sm "></mat-icon>-->
      <!--          <span>{{ "Kutoka" |concat|translate }}</span>-->
      <!--        </button>-->
      <!--      </li>-->

      <button (click)="toggleNav()" class="md:!hidden inline-block !ml-auto" mat-icon-button>
        <mat-icon>list</mat-icon>
      </button>
    </ul>

    <div #mobileMenu class="absolute left-0 right-0 pl-4 mobile-toggle" style="top: 55px;">
      <ul class="flex flex-col nav-links items-end lg:text-md md:text-sm text-xs font-bold py-2">
        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100 " (click)="handleHover(null)">
          <a
            routerLink="/home"
            routerLinkActive="text-primary-500 border-b-2 border-primary-500"
            #homeRla="routerLinkActive"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span> {{ "Mwanzo" |concat|translate }}</span>
            <mat-icon class="align-middle text-sm">
              {{ homeRla.isActive ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100 " (click)="handleHover('about-tgsd')">
          <a
            [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('about-tgsd')}"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span> {{ "Kuhusu Dirisha"|concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">
              {{ activeMenu('about-tgsd') ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100 " (click)="handleHover('huduma-tgsd')">
          <a
            [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('huduma-tgsd')}"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span> {{ "Huduma zote"|concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">
              {{ activeMenu('huduma-tgsd') ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100 " (click)="handleHover('dharura-tgsd')">
          <a
            [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('dharura-tgsd')}"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span>{{ "Dharura" |concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">
              {{ activeMenu('dharura-tgsd') ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100 " (click)="handleHover('faq-tgsd')">
          <a
            [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('faq-tgsd')}"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span>{{ "FAQs" |concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">
              {{ activeMenu('faq-tgsd') ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100 " (click)="handleHover('mrejesho-tgsd')">
          <a
            [ngClass]="{ 'border-b-2 border-primary-500':activeMenu('mrejesho-tgsd')}"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span>{{ "Mrejesho" |concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">
              {{ activeMenu('mrejesho-tgsd') ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100" (click)="handleHover('msaada-ai')">
          <a
            href="https://msaadaai.all.tz"
            target="_blank"
            class="flex items-end text-primary-600 hover:border-b-2 border-primary-500 hover:text-primary-500 pb-1 transition"
          >
            <span>{{ "Msaada AI" |concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">
              {{ activeMenu('msaada-ai') ? 'south_west' : 'north_east' }}
            </mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100" *ngIf="!userProfile"
            (click)="handleHover(null)">
          <a
            routerLink="/login"
            routerLinkActive="text-primary-500 border-b-2 border-primary-500"
            #loginRla="routerLinkActive"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition"
          >
            <span>{{ "Ingia/Jisajili" |concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">north_east</mat-icon>
          </a>
        </li>

        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100"
            *ngIf="userProfile?.profileType === 'CIT'"
            (mouseover)="handleHover(null)">
          <a
            routerLink="/client-services"
            routerLinkActive="text-primary-500 border-b-2 border-primary-500"
            #loginRla="routerLinkActive"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition">
            <span>{{ "Dashboard"|concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">north_east</mat-icon>
          </a>
        </li>
        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100"
            *ngIf="userProfile?.profileType === 'CIT'"
            (mouseover)="handleHover(null)">
          <a
            routerLink="/user-profile"
            routerLinkActive="text-primary-500 border-b-2 border-primary-500"
            #loginRla="routerLinkActive"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition">
            <span>{{ "Profile"|concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">north_east</mat-icon>
          </a>
        </li>
        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100"
            *ngIf="userProfile?.profileType === 'CIT'"
            (mouseover)="handleHover(null)">
          <a
            routerLink="/change-password"
            routerLinkActive="text-primary-500 border-b-2 border-primary-500"
            #loginRla="routerLinkActive"
            class="flex items-end text-primary-600 hover:text-primary-500 pb-1 transition">
            <span>{{ "Change Password"|concat|translate }}</span>
            <mat-icon class="align-middle text-sm ">north_east</mat-icon>
          </a>
        </li>


        <li class="cursor-pointer bg-white w-6/12 border-b border-primary-100" *ngIf="userProfile"
            (mouseover)="handleHover(null)">
          <button
            (click)="logout()"
            class="flex items-end text-primary-600 mx-auto  hover:text-red-600 gap-2 pb-1 transition"
          >
            <mat-icon svgIcon="logout" class="align-middle  text-sm "></mat-icon>
            <span>{{ "Kutoka" |concat|translate }}</span>
          </button>
        </li>
      </ul>

    </div>

    <div class="relative w-full">
      <app-huduma-tgsd (exitHover)="handleHover($event)" (mouseleave)="handleHover(null)"
                       [ngClass]="activeMenu('huduma-tgsd') ? 'block':'hidden'"></app-huduma-tgsd>
      <app-dharura-tgsd (exitHover)="handleHover($event)" (mouseleave)="handleHover(null)"
                        [ngClass]="activeMenu('dharura-tgsd') ? 'block':'hidden'"></app-dharura-tgsd>
      <app-faq-tgsd (exitHover)="handleHover($event)" (mouseleave)="handleHover(null)"
                    [ngClass]="activeMenu('faq-tgsd') ? 'block':'hidden'"></app-faq-tgsd>
      <app-about-tgsd (exitHover)="handleHover($event)" (mouseleave)="handleHover(null)"
                      [ngClass]="activeMenu('about-tgsd') ? 'block':'hidden'"></app-about-tgsd>
      <app-mrejesho-search-tgsd (exitHover)="handleHover($event)" (mouseleave)="handleHover(null)"
                                [ngClass]="activeMenu('mrejesho-tgsd') ? 'block':'hidden'"></app-mrejesho-search-tgsd>
    </div>
  </nav>


</div>


<mat-menu #userMenu="matMenu">
  <button mat-menu-item routerLink="/user-profile">
    <mat-icon svgIcon="person"></mat-icon>
    {{ 'Profile' | concat | translate }}
  </button>

  <button mat-menu-item routerLink="/change-password">
    <mat-icon svgIcon="password_key"></mat-icon>
    {{ 'Change Password' | concat | translate }}
  </button>
  <mat-divider class="gradient"></mat-divider>

  <mat-divider class="gradient"></mat-divider>
  <button (click)="logout()" mat-menu-item>
    <mat-icon svgIcon="logout"></mat-icon>
    {{ 'Logout' | concat | translate }}
  </button>
</mat-menu>
